const domainName = process.env.GATSBY_DOMAIN
const formattedDomainName = (
  domainName.charAt(0).toUpperCase() + domainName.slice(1)
).replace('shaadi', 'Shaadi')
const baseUrl = `https://www.${process.env.GATSBY_DOMAIN}`
const myDotUrl = `https://my.${domainName}`
const baseDomain = formattedDomainName.split('.')[0]
const domainType = domainName === 'shaadi.com' ? 'Main' : 'Community'

const getGoogleClienIdMapping = () => {
  switch (domainName) {
    case 'shaadi.com':
    case 'marathishaadi.com':
    case 'tamilshaadi.com':
    case 'kannadashaadi.com':
    case 'punjabishaadi.com':
    case 'bengalishaadi.com':
    case 'telugushaadi.com':
    case 'gujaratishaadi.com':
    case 'malayaleeshaadi.com':
      return process.env.GOOGLE_LOGIN_CLIENT_ID_MAIN

    case 'muslimshaadi.in':
    case 'odiashaadi.com':
    case 'sindhishaadi.in':
    case 'tulushaadi.com':
    case 'urdushaadi.com':
    case 'jainshaadi.in':
    case 'sikhshaadi.in':
    case 'parsishaadi.com':
    case 'hindishaadi.com':
    case 'nri-shaadi.com':
      return process.env.GOOGLE_LOGIN_CLIENT_ID_SECOND

    case 'marwarishaadi.in':
    case 'assameseshaadi.com':
    case 'buddhistshaadi.in':
    case 'christianshaadi.com':
    case 'manipurishaadi.com':
    case 'kashmirishaadi.com':
    case 'hindushaadi.in':
    case 'konkanishaadi.com':
      return process.env.GOOGLE_LOGIN_CLIENT_ID_LAST
  }
}

export {
  domainName,
  formattedDomainName,
  baseUrl,
  myDotUrl,
  baseDomain,
  domainType,
  getGoogleClienIdMapping,
}
